import React, { useEffect, useRef, useState } from 'react'
import env from 'config/env'
import useBestsellers from 'components/shared/useSWR/useBestsellers'
import useIntersection from 'components/custom-hooks/useIntersection'
import useWindowSize from 'components/custom-hooks/useWindowSize'
import RenderProductList from '../render-product-list'

const ProductSection = () => {
  const [isContainerShown, setIsContainerShown] = useState(true)
  const ref = useRef()
  const isIntersecting = useIntersection(ref, { threshold: 0.1 })
  const windowWidth = useWindowSize().width
  const { data: productList, error: productListError } = useBestsellers(
    env.TTB_CATEGORY_ID,
  )

  useEffect(() => {
    if (productListError || productList?.length === 0) {
      setIsContainerShown(false)
    }
  }, [productListError, productList, setIsContainerShown])

  if (!isContainerShown) {
    return null
  }

  return (
    <div
      className="ttb-product__product-container"
      role="presentation"
      ref={ref}
    >
      {isIntersecting && (
        <RenderProductList
          productList={productList}
          windowWidth={windowWidth}
        />
      )}
    </div>
  )
}

export default ProductSection
